<template>
  <b-card-body v-if="value != null">
    <!-- 
      <b-form-group>
        <b-form-input placeholder="Kenmerk" />
      </b-form-group> 
    -->
  
    <b-form-group label="Geldig voor typen units">
      <!-- selecteer unittypen in value.details.unitTypen -->
      <b-form-checkbox-group
        v-model="value.details.unitTypen"
        :options="typen"
        switch
        name="typen"
      />
      <b-button @click="selectAll">
        Alle typen
      </b-button>
    </b-form-group>

    <!-- <b-form-group>
      <b-input-group>
        <b-input v-model="type"/>
      </b-input-group>
    </b-form-group> -->

    <b-table 
      :items="value.details.categorieen"
      :fields="fields"
      dark 
      small
      bordered
      striped
      hover
      caption-top
      caption="Afspraken per categorie" 
    >
      <template #cell(onderhoudscategorie)="data">
        {{ data.item.onderhoudscategorie }}
      </template>
      <!-- default data slot table -->
      <template #cell()="data">
        <!-- no input default value to null -->
        <b-input-group>
          <b-input
            v-model.number="data.item[data.field.key]"
            :placeholder="data.field.label" 
            :state="!isNaN(data.item[data.field.key]) ? true : false"
          /><b-input-group-append>
            <b-button @click="data.item[data.field.key] = null">
              <font-awesome-icon icon="times" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </template>
      <template #cell(acties)="data">
        <b-button 
          variant="ghost" 
          @click="value.details.categorieen.splice(data.index, 1)"
        >
          <font-awesome-icon 
            icon="trash" 
          />
        </b-button>
      </template>
    </b-table>
   
    <!-- add categorie A,B,C and Z if it does not exists in value.details.categorieen -->
    <b-button-group>
      <b-button 
        v-for="categorie in ['A','B','C','Z']" 
        :key="categorie"
        :disabled="value.details.categorieen.find(item => item.onderhoudscategorie === categorie) !== undefined"
        variant="outline-primary"
        @click="addCategorie(categorie)"
      >
        {{ categorie }} toevoegen
      </b-button>
    </b-button-group>
  </b-card-body>
</template>
  <script>
  export default {
      name: 'KpiAfspraak',
      components: {},
      mixins: [],
      props: {
        value: {
          type: Object,
          required: true
        },
        type: {
          type: String,
          required: true
        }
      },
      data() {
          return  {
            typen: ['LT','LH','RT', 'TA','GE', 'PL', 'DE'],
             fields: [
              {
                key: 'onderhoudscategorie', 
                label: 'Categorie',
              },
              {
                key: 'responseTO',
                label: 'Response TO',
              },
              {
                key: 'responsetijd',
                label: 'Response OPSL.',
              },
              {
                key: 'oplostijden',
                label: 'Oplostijd',
              },
              {
                key: 'stilstandStoring',
                label: 'Stilstand ST',
              },
              {
                key: 'stilstand12Maanden',
                label: 'Stilstand 12mnd',
              },
              {
                key: 'beschikbaarheid',
                label: 'Beschikbaarheid',
              },
              {
                key: 'aantalStoringenTO',
                label: 'Aantal TO',
              },
              {
                key: 'aantalStoringenVA',
                label: 'Aantal VA',
              },
              {
                key: 'aantalStoringenLM',
                label: 'Aantal storingen LM',
              },
              {
                key: 'aantalStoringenOG',
                label: 'Aantal storingen OG',
              },
              {
                key: 'afkeuringen',
                label: 'Aantal afkeuringen',
              },
              {
                key: 'conditieVermindering',
                label: 'Conditie vermindering',
              },
              {
                key: 'preventiefOnderhoud',
                label: 'Preventief Onderhoud',
              },
              {
                key: 'acties',
                label: 'Acties',
              }
            ]
          }
      },
      computed: {},
      watch: {},
      mounted () {
          
      },
      methods: {
        selectAll() {
          this.value.details.unitTypen = this.typen
        },
        addCategorie(categorie) {
          this.value.details.categorieen.push({
            onderhoudscategorie: categorie,
            responseTO: 0,
            responsetijd: 0,
            oplostijden: 0,
            stilstandStoring: 0,
            stilstand12Maanden: 0,
            beschikbaarheid: 0,
            aantalStoringenTO: 0,
            aantalStoringenVA: 0,
            aantalStoringenLM: 0,
            aantalStoringenOG: 0,
            afkeuringen: 0,
            conditieVermindering: 0,
            preventiefOnderhoud: 0,
          })
        }
      },
            
  }
  </script>